import { NgModule } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';

import { TableCardComponent } from './table-card.component';
import { TableCardRowComponent } from './table-card-row/table-card-row.component';
import { TableCardColumnComponent } from './table-card-column/table-card-column.component';
import { TableCardItemComponent } from './table-card-item/table-card-item.component';

const COMPONENTS = [
  TableCardComponent,
  TableCardRowComponent,
  TableCardColumnComponent,
  TableCardItemComponent,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [CommonModule, NgOptimizedImage],
  exports: [...COMPONENTS],
})
export class TableCardModule {}
